import React from 'react';
import * as styles from '../ExpiredPlanSelectionModal.module.scss';
import { PlanOptionSelectSection } from './PlanOptionSelectSection';
import { PlanOptionBenefitsSection } from './PlanOptionBenefitsSection';

type PlanOptionProps = {
  plan: any;
};

export const PlanOption = ({ plan }: PlanOptionProps) => {
  return (
    <div className={styles.PlanOption_wrapper}>
      <PlanOptionSelectSection plan={plan} />
      <PlanOptionBenefitsSection plan={plan} />
    </div>
  );
};
